<div class="modal fade" [id]="modalId" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered maxw-640">
        <div class="modal-content maxh-660">
            <div class="modal-header align-items-center pl-4 pr-2 py-2">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">&times;</button>
                <div class="d-flex align-items-center">
                    <ul class="nav btn-title-tab-group">
                        <li class="nav-item" (click)="activeTab = 0">
                            <a class="nav-link btn-tab" id="#tags-select-tab" data-bs-toggle="tab" href="#tags-select"
                                role="tab" aria-selected="true" [class.active]="activeTab == 0">
                                {{ 'tags.select' | translate | uppercase }}
                            </a>
                        </li>
                        <li [canWrite]="'ManageTags'" class="nav-item" (click)="activeTab = 1">
                            <a class="nav-link btn-tab" id="#tags-addnew-tab" data-bs-toggle="tab" href="#tags-addnew"
                                role="tab" aria-selected="false" [class.active]="activeTab == 1">
                                {{ 'tags.addNew' | translate | uppercase }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="modal-body">
                <div class="tab-content">

                    <div class="tab-pane fade active show" id="tags-select" role="tabpanel"
                        [class.active]="activeTab == 0" [class.show]="activeTab == 0">
                        <div class="form-col pt-4">
                            <div class="list-item-collapsible-content">
                                <app-tags [tagType]="'RESERVATION'" [modalId]="modalId"
                                    [tagCategories]="tagCategories" [selectedTags]="tagsSelection"
                                    (setTags)="setReservationTags($event)" [displayCategoryLabel]="displayCategoryLabel"
                                    [displayAdditionalTextInput]="displayAdditionalTextInput"
                                    [additionalTextInput]="_additionalTextInput"
                                    (setAdditionalTextInput)="onSetAdditionalTextInput($event)"></app-tags>
                            </div>
                        </div>
                    </div>

                    <div [canWrite]="'ManageTags'" class="tab-pane fade" id="tags-addnew" role="tabpanel" [class.active]="activeTab == 1"
                        [class.show]="activeTab == 1">
                        <div class="form-col pt-4">
                            <app-dropdown *ngIf="selectedTag.id == ''" [(model)]="selectedTag.categoryId"
                                [items]="tagCategories" [displayProperty]="'name'" [valueProperty]="'id'"
                                (modelChange)="updateValidity()" style="display: block" class="mb-2" noSelectionText="{{ 'reservationTags.placeholders.selectCategory' | translate }}">
                            </app-dropdown>

                            <input [(ngModel)]="selectedTag.title" (ngModelChange)="updateValidity()" type="text"
                                class="ihost-control w-100 mb-2"
                                placeholder="{{ 'reservationTags.placeholders.tag' | translate }}" />

                            <!-- <input *ngIf="selectedTag.id != ''" [(ngModel)]="selectedTag.tagOrder" type="number" min="1" step="1"
                                class="ihost-control w-100 mb-2" (ngModelChange)="updateValidity()"
                                placeholder="{{ 'reservationTags.placeholders.tagOrder' | translate }}" /> -->
                            <div>
                                <span>{{tagErrorMessage}}</span>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

            <div class="modal-footer align-items-center py-2">
                <ng-container *ngIf="activeTab == 0">
                    <button type="button" class="btn btn-faded" (click)="closeModal(false)">
                        {{ 'common.buttons.cancel' | translate }}</button>
                    <button type="button" class="btn btn-main" (click)="closeModal(true)">{{
                        'reservations.customerDetails.saveCustomer' | translate }}</button>
                </ng-container>
                <ng-container *ngIf="activeTab == 1">
                    <button type="button" class="btn btn-faded" (click)="cancelAddTag()">
                        {{ 'common.buttons.cancel' | translate }}</button>
                    <button type="button" class="btn btn-main" (click)="saveTag(selectedTag)">{{
                        'reservations.customerDetails.saveCustomer' | translate }}</button>
                </ng-container>
            </div>

        </div>
    </div>
</div>